import { useEffect, useState } from 'react';
import { nhost } from 'src/lib/nhost';

export const useGetImageUrl = (imageId: string | null | undefined) => {
  const [imageUrl, setImageUrl] = useState<string | undefined>(undefined);

  // useEffect(() => {
  //   console.log('LOOOOL', imageId);

  //   async function fetchPresignedUrl() {
  //     const { presignedUrl, error } = await nhost.storage.getPresignedUrl({ fileId: imageId });
  //     if (error) {
  //       throw new Error(`Failed to fetch Image: ${error?.message}`);
  //     } else {
  //       setImageUrl(presignedUrl?.url ?? undefined);
  //     }
  //   }

  //   fetchPresignedUrl();
  // }, [imageId]);

  // return { imageUrl };

  useEffect(() => {
    async function fetchPresignedUrl() {
      try {
        if (!imageId) {
          setImageUrl('/assets/img/logo-placeholder.jpg');
          return;
        }
        const imageUrl = await nhost.storage.getPublicUrl({ fileId: imageId });
        setImageUrl(imageUrl);
      } catch (error) {
        throw new Error(`Error getting Images, ${error}`);
      }
    }
    fetchPresignedUrl();
  }, [imageId]);

  return { imageUrl };
};
